import { Trash2 } from 'lucide-react';
import { useMultiplePayment } from '../../../../hooks/sale/useMultiplePayment';
import { useSale } from '../../../../hooks/sale/useSale';
import { salePaymentColumns } from '../../../../features/sale/payment/salePaymentColumns';
import ModalBasicTable from '../../../Tables/ModalBasicTable/ModalBasicTable';
import useConfirm from '../../../../hooks/useConfirmModal';

interface Props {
  onEdit: (payment: any) => void;
}

const PaymentMethodTable: React.FC<Props> = ({ onEdit }) => {
  const { payments, deletePayment, deleteAllPayments } = useMultiplePayment();
  const { form } = useSale();
  const confirm = useConfirm();

  const saleId = form?.id;

  const actions = (row: (typeof payments)[number]) => [
    {
      key: 'edit',
      onClick: () => onEdit(row),
    },
    {
      key: 'delete',
      onClick: async () => {
        if (!saleId) return;

        await deletePayment(saleId, row.id);
      },
    },
  ];

  const handleDeleteAll = () => {
    if (!saleId || payments.length === 0) return;

    confirm({
      title: '¿Eliminar todos los pagos?',
      message: 'Se eliminarán todos los pagos registrados para esta venta.',
      icon: 'warning',
      confirmText: 'Eliminar todos',
      cancelText: 'Cancelar',
      onConfirm: () => deleteAllPayments(saleId),
    });
  };

  return (
    <div className="flex flex-col gap-3">
      {payments.length > 0 && (
        <div className="flex justify-end">
          <button
            type="button"
            onClick={handleDeleteAll}
            className="flex items-center gap-1.5 rounded-md border border-danger/30 px-3 py-1.5 text-xs font-medium text-danger transition-all hover:bg-danger hover:text-white"
          >
            <Trash2 size={14} />
            Eliminar todos los pagos
          </button>
        </div>
      )}

      <ModalBasicTable
        columns={salePaymentColumns}
        data={payments}
        actions={actions}
        pageSize={5}
        maxHeight="max-h-[350px]"
        noDataMessage="No hay pagos registrados."
      />
    </div>
  );
};

export default PaymentMethodTable;
